<template>
  <div class="col-xl-12">
    <div class="card vh-75" id="scroll">
      <div class="table-responsive">
        <div v-if="loading" class="loader">
          <img src="@/assets/img/loader.svg" alt="" />
        </div>
        <table
          class="table align-items-center table-flush table-hover bidtbl"
          style="min-height: 125px"
        >
          <thead class="thead-light psticky">
            <tr>
              <th scope="col" class="sort text-center">QTY</th>
              <th scope="col" class="sort text-center">PRICE</th>
              <th scope="col" class="sort text-center">ECN</th>
              <th scope="col" class="sort text-center">SETTLEMENT DATE</th>
              <th scope="col" class="sort text-left">Collection Details</th>
            </tr>
          </thead>
          <tbody class="list no-cursor">
            <tr v-if="bidwantedList.length == 0 && !loading">
              <td><p class="nodata">No data available</p></td>
            </tr>
            <tr v-for="(data, indexBid) in bidwantedList" :key="indexBid">
              <td class="text-center">{{ data.orderQty }}</td>
              <td class="text-center">{{ data.bidPrice }}</td>
              <td class="text-center">
                {{ data.ecn }}
              </td>
              <td class="text-center">
                {{
                  data.settleDate
                    ? moment(data.settleDate).format("MM/DD/YYYY")
                    : "N/A"
                }}
              </td>
              <td class="text-left">
                <span v-if="data.ecn == 'IBP'"
                  ><span class="maturity">Collecting Until</span> :
                  <span class=""
                    >{{
                      data.bidBy
                        ? moment
                            .utc(data.bidBy)
                            .tz("America/New_York")
                            .format("hh:mm:ss a")
                        : "N/A"
                    }}
                    EST</span
                  ></span
                >
                <span v-if="data.ecn == 'TMC'">
                  <div>
                    <span class="maturity">Collecting Until</span> :
                    <span class=""
                      >{{
                        data.bidBy
                          ? moment
                              .utc(data.bidBy)
                              .tz("America/New_York")
                              .format("hh:mm:ss a")
                          : "N/A"
                      }}
                      EST</span
                    >
                  </div>
                  <div>
                    <span class="maturity">Firm Until</span> :
                    <span class=""
                      >{{
                        data.firmUntill
                          ? moment
                              .utc(data.firmUntill)
                              .tz("America/New_York")
                              .format("hh:mm:ss a")
                          : "N/A"
                      }}
                      EST</span
                    >
                  </div>
                </span>
                <span v-if="data.ecn == 'TWD'">
                  <div>
                    <span class="maturity">Collection Type</span> :
                    <span class="">{{ data.collectionTypeDisplay }}</span>
                  </div>
                  <div>
                    <span class="maturity">Collecting Until</span> :
                    <span class=""
                      >{{
                        data.bidBy
                          ? moment
                              .utc(data.bidBy)
                              .tz("America/New_York")
                              .format("hh:mm:ss a")
                          : "N/A"
                      }}
                      EST</span
                    >
                  </div>
                  <div v-if="data.collectionType == 'OPEN'">
                    <span class="maturity">Firm Until</span> :
                    <span class=""
                      >Bid time +{{
                        data.goodForTime
                          ? data.goodForTime / 60 + "Mins"
                          : "N/A"
                      }}
                      EST</span
                    >
                  </div>
                  <div v-if="data.collectionType != 'OPEN'">
                    <span class="maturity">Firm Until</span> :
                    <span class=""
                      >{{
                        moment
                          .utc(data.postAtTime)
                          .add(data.goodForTime, "seconds")
                          .tz("America/New_York")
                          .format("hh:mm:ss a")
                      }}
                      EST</span
                    >
                  </div>
                  <div v-if="data.collectionType != 'DEFINEDWOREVIEW' && data.collectionType != 'OPEN' ">
                    <span class="maturity">Review Period</span> :
                    <span class=""
                      >{{
                        moment(data.postAtTime).diff(data.bidBy, "minutes")
                      }}
                      Mins
                    </span>
                  </div>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
          class="mt-4"
          :total-rows="totalRows"
          v-model="currentPage"
          :per-page="perPage"
          @input="getBidwantedList(currentPage)"
        ></b-pagination>
        <div class="total-records">
          <span>Total Records : {{ totalRows }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import authService from "@/authService";
import config from "@/config";
export default {
  name: "todaybid",
  components: {},
  props: ["cusip"],
  data() {
    return {
      loading: false,
      currentPage: 1,
      perPage: 25,
      searchValue: this.cusip,
      totalRows: 0,
      sortColumn: "id",
      sortOrder: "DESC",
      status: [
        "BID_SENDING",
        "BID_SENT",
        "ORDER_RECEIVED",
        "ACCEPTED",
        "REJECTED",
        "SUCCESS",
        "BID_CANCELLED",
        "TRADED_AWAY",
        "SUBJECT",
        "TRADE_CANCELLED",
        "DID_NOT_TRADE",
      ],
      bidwantedList: [],
    };
  },
  methods: {
    getBidwantedList() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let currentDate = "";
      let today = this.moment().format("MM-DD-YYYY");
      let fromDate = this.moment(today).utc().format("YYYY-MM-DD HH:mm:ss");
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=" +
            this.status +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&currentDate=" +
            currentDate +
            "&loggedUser="+
            authService.getUser().id+
            "&fromDate=" +
            fromDate,
          auth
        )
        .then((result) => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach((element) => {
            if (element.collectionType == "OPEN") {
              element.collectionTypeDisplay = "Open";
            }
            if (element.collectionType == "DEFINEDWREVIEW") {
              element.collectionTypeDisplay = "Defined With Review  ";
            }
            if (element.collectionType == "DEFINEDWOREVIEW") {
              element.collectionTypeDisplay = "Defined Without Review";
            }
          });
          this.bidwantedList = result.data.content;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
  },
  mounted() {
    this.getBidwantedList();
  },
};
</script>